import { editStaffProvidersApiRequest, getUsersApiRequest, getUsersStaffApiRequest, inviteUserApiRequest, updateUserStatusApi } from '@guryou/api-client';
import { addFrancescoAsDirectorToProviderApiCall } from '@guryou/api-client-gql';
import { ActionStatus, buildActionType, executeApiCall } from '../core';
import { ADD_FRANCESCO_AS_DIRECTOR, STAFF_PROVIDERS_ASSIGNED_GET, STAFF_PROVIDERS_EDIT, STAFF_PROVIDERS_NONASSIGNED_GET, STAFF_RESOURCES_FILTER, USERS_FILTER, USERS_GET_MANY, USERS_POST, USERS_STAFF_GET, USERS_STATUS } from '../types';
const getUsers = () => async dispatch => dispatch(executeApiCall(getUsersApiRequest(), USERS_GET_MANY));
const setUserFilters = filter => dispatch => dispatch({
  type: buildActionType(USERS_FILTER, ActionStatus.START),
  payload: filter
});
const getStaff = id => async dispatch => dispatch(executeApiCall(getUsersStaffApiRequest(id), USERS_STAFF_GET));
const setStaffProviders = (providers, assignedIds) => async dispatch => {
  const filtered = providers.filter(prov => assignedIds.includes(prov.providersId));
  const nonassigned = providers.filter(prov => !assignedIds.includes(prov.providersId));
  dispatch({
    type: buildActionType(STAFF_PROVIDERS_ASSIGNED_GET, ActionStatus.DONE),
    payload: filtered
  });
  dispatch({
    type: buildActionType(STAFF_PROVIDERS_NONASSIGNED_GET, ActionStatus.DONE),
    payload: nonassigned
  });
};
const setStaffResources = (resources, providerId) => async dispatch => {
  const filtered = resources.filter(res => res.providersId === providerId);
  dispatch({
    type: buildActionType(STAFF_RESOURCES_FILTER, ActionStatus.DONE),
    payload: filtered
  });
};
const editStaffProviders = (id, data) => async dispatch => {
  dispatch(executeApiCall(editStaffProvidersApiRequest(id, data), STAFF_PROVIDERS_EDIT));
};
const resetStaffProviders = () => async dispatch => dispatch({
  type: buildActionType(STAFF_PROVIDERS_EDIT, ActionStatus.RESET)
});
const setUsersStatus = users => async dispatch => dispatch({
  type: buildActionType(USERS_STATUS, ActionStatus.DONE),
  payload: users
});
const updateUsersStatus = id => async dispatch => {
  dispatch({
    type: buildActionType(USERS_STATUS, ActionStatus.START)
  });
  const response = await updateUserStatusApi(id);
  return !!response.success;
};
const inviteCollaborator = data => async dispatch => dispatch(executeApiCall(inviteUserApiRequest(data), USERS_POST));
const addFrancescoAsDirector = id => async dispatch => dispatch(executeApiCall(addFrancescoAsDirectorToProviderApiCall({
  id
}), ADD_FRANCESCO_AS_DIRECTOR));
export { getUsers, updateUsersStatus, setUserFilters, getStaff, setStaffProviders, setStaffResources, editStaffProviders, resetStaffProviders, setUsersStatus, inviteCollaborator, addFrancescoAsDirector };